<script>
import Markdown from 'markdown-it'
import CandelaComponent from '@/components/CandelaComponent'

const MD = new Markdown()

export default {
  computed: {
    md() {
      return MD.render(this.text)
    }
  },
  extends: CandelaComponent,
  name: 'candela-markdown',
  props: {
    text: {type: String, default: () => ''}
  }
}
</script>

<template>
<div class='candela-component md-container flex-grow-1 flex-shrink-0'>
  <v-card-text class='md ma-0 pa-3'>
    <div v-html='md'/>
  </v-card-text>
</div>
</template>

<style lang='sass' scoped>
.md-container
  max-height: 100%

.md
  max-height: 100%
  overflow-y: auto

.theme--light
  .md-container
    border: 1px solid var(--v-grey-lighten6)

.theme--dark
  .md-container
    border: 1px solid var(--v-grey-darken6)

::v-deep .md
  h1, h2, h3, h4, h5, h6, p
    font-size: 2.1em
    letter-spacing: 0.02em
    line-height: 1.0em
    margin-bottom: 0.2em
    margin-top: 0.2em

  h2
    font-size: 1.6em

  h3
    font-size: 1.4em

  h4
    font-size: 1.2em

  h5
    font-size: 1.0em

  h6
    font-size: 0.9em

  p
    font-size: 1.1em
    letter-spacing: 0.04em
    line-height: 1.2em
    margin-bottom: 0.5em
    margin-top: 0.5em
</style>
